import React, { useState } from "react";
import "./DDCertificates.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function DDCertificates() {
  const [form, setForm] = useState({
    receiptNo: "",
    date: "",
    receivedFrom: "",
    acNo: "",
    nomineeName: "",
    typesOfDeposit: "",
    age: "",
    relation: "",
  });
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const generatePDF = async () => {
  const input1 = document.getElementById('page1');
  const input2 = document.getElementById('page2');
  const pdf = new jsPDF("p", "mm", "a4");
  // page 1

  const canvas1 = await html2canvas(input1, { scale: 2, useCORS: true , backgroundColor: "#ffffffff" });
  const imgData1 = canvas1.toDataURL('image/png');
  const imgWidth1 = 210;
  const pageHeight1 = 297;
  const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;
  pdf.addImage(imgData1, 'PNG', 0, 0, imgWidth1, imgHeight1);

  // page 2 
  pdf.addPage();
  const canvas2 = await html2canvas(input2, { scale: 2 , useCORS: true , backgroundColor: "#ffffffff"});
  const imgData2 = canvas2.toDataURL('image/png');
  const imgWidth2 = 210;
  const pageHeight2 = 297;
  const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;
  pdf.addImage(imgData2, 'PNG', 0, 0, imgWidth2, imgHeight2);

  pdf.save("DD_Certificate.pdf");
};

 const data = {
    receipt: "12324",
    nomineeName: "Mahendra Singh ",
    receivedFrom: "alka Yagini",
 }


  
  return (
    <div className="DDcertificates-containers">
      <div id="page1">
    <div className="DDcertificates-container">
      <div className="DDcertificates-box">
        <div className="DDheaders">
          <div className="DDlefts">
            <div className="DDlogos">Logo
            <img src="techvisionproject\src\assets\image\Screenshot 2025-09-24 111702.png" alt="Logo" />
            </div>
            <div>
              <h1 className="DDtitles">SANPANNATA MUTUAL BENEFIT NIDHI LIMITED.</h1>
              <p className="DDsubtitles">Reg. No. : U64199MH2023PLN405930</p>
              <p className="DDsubtitles">
                Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,
                Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra
              </p>
            </div>
          </div></div>
          <div className="dd-header-container">
  <div className="dd-header-line"></div>

  <div className="dd-header-banner">
    <span className="dd-header-text-hindi">डिमांड ड्राफ्ट प्रमाणपत्र</span>
    <span className="dd-header-separator">/</span>
    <span className="dd-header-text-english">Demand Draft Certificate</span>
  </div>

  <div className="dd-header-line"></div>

  <div className="dd-header-office-copy">Office Copy</div>
</div>

        

        <div className="DDinfos-section">
          <div className="DDlefts-info">
            <div className="DDfields">
              <label> Receipt No. &nbsp;&nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{data.receipt}<br />(रसीद संख्या)</label>
              {/* <input name="receiptNo" value={form.receiptNo} /> */}
            </div>
            
            <div className="DDfields">
              <label>Received From Shri/Smt. &nbsp;&nbsp;:-  &nbsp;&nbsp;{data.receivedFrom} <br /> (श्री/श्रीमती से प्राप्त) </label>
              {/* <input name="receivedFrom" value={form.receivedFrom}  /> */}

            </div>
            <div className="DDfields">
              <label> A/C. No. &nbsp;&nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(खाता सं.)</label>
              {/* <input name="acNo" value={form.acNo}  /> */}
            </div>
            <div className="DDfields">
              <label>Nominee Name  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.nomineeName}<br />(नामांकित व्यक्ति का नाम)</label>
              {/* <input name="nomineeName" value={form.nomineeName} /> */}
            </div>
            <div className="DDfields">
              <label>Types of Deposit   &nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(जमा के प्रकार)</label>
              {/* <input
                name="typesOfDeposit"
                value={form.typesOfDeposit}
                
              /> */}
            </div>
          </div>

          <div className="DDrights-info">
            <div className="DDfields">
              <label> Date &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt} <br />(दिनांक)</label>
              {/* <input name="date" value={form.date}  /> */}
            </div>
            <div className="DDfields">
              <label>Age &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(आयु)</label>
              {/* <input name="age" value={form.age}  /> */}
            </div>
            <div className="DDfields">
              <label>Relation &nbsp; :-&nbsp;&nbsp;&nbsp;{data.receipt}<br />(रिश्ता)</label>
              {/* <input name="relation" value={form.relation} /> */}
            </div>
            <div className="DDfields">
              <label>A/C. No. &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(खाता सं.)</label>
              {/* <input name="acNo" value={form.acNo}  /> */}
            </div>
          </div>
        </div>

     
    <div className="DDCdeposit-table">
      <table>
        <thead>
          <tr>
            <th>
              {/* Per Month Rs. <br /> */}
              <span className="DDCsub">Per Month Rs. <br /> प्रति माह रु.</span>
            </th>
            <th colSpan="2">
              
              <span className="DDCsubs">Deposit Date / जमा तिथि</span>
              <div className="DDCsub-header">
                <div className="DDCsub">Start Date <br /> प्रारंभ तारीख</div>
                <div className="DDCsub">Maturity Date <br /> परिपक्वता तिथि</div>
              </div>
            </th>
            <th>
              {/* Duration <br /> */}
              <span className="DDCsub">Duration <br /> अवधि</span>
            </th>
            <th>
              {/* Interest Rate <br /> */}
              <span className="DDCsub">Interest Rate <br /> व्याज दर</span>
            </th>
            <th>
              {/* Due Date <br /> */}
              <span className="DDCsub">Due Date <br />नियत तारीख</span>
            </th>
            <th>
              {/* Maturity Amt. <br /> */}
              <span className="DDCsub">Maturity Amt.<br /> परिपक्वता राशि</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td className="inner"></td>
            <td className="inner"></td>
            <td> <br /><br /><br />  </td>
            <td>   </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
     <div className="DDfooter">
          <div><br /> Cashier / कैशियर</div>
          <div><br /> Br. Manager / शाखाप्रमुख</div>
          <div><br /> Chairman / अध्यक्ष</div>  
      </div>
      </div>   </div>

       
        <div className="divider"></div>
      {/* End of 1st Container */}

      {/* Start of 2nd  Container */}
      
<div className="DDcertificates-container">
      <div className="DDcertificates-box">
        <div className="DDheaders">
          <div className="DDlefts">
            <div className="DDlogos">
                <img src="techvisionproject\src\assets\image\Screenshot 2025-09-24 111702.png" alt="Logo" />

            </div>
            <div>
              <h1 className="DDtitles">SANPANNATA MUTUAL BENEFIT NIDHI LIMITED.</h1>
              <p className="DDsubtitles">Reg. No. : U64199MH2023PLN405930</p>
              <p className="DDsubtitles">
                Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,
                Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra
              </p>
            </div>
          </div></div>
       <div className="dd-header-container">
  <div className="dd-header-line"></div>

  <div className="dd-header-banner">
    <span className="dd-header-text-hindi">डिमांड ड्राफ्ट प्रमाणपत्र</span>
    <span className="dd-header-separator">/</span>
    <span className="dd-header-text-english">Demand Draft Certificate</span>
  </div>

  <div className="dd-header-line"></div>

  <div className="dd-header-office-copy">Customer Copy</div>
</div>

        

        <div className="DDinfos-section">
          <div className="DDlefts-info">
            <div className="DDfields">
              <label>  Receipt No.  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp; {data.receipt}<br />(रसीद संख्या)</label>
              {/* <input name="receiptNo" value={form.receiptNo}  /> */}
            </div>
            
            <div className="DDfields">
              <label>Received From Shri/Smt.  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(श्री/श्रीमती से प्राप्त)</label>
              {/* <input name="receivedFrom" value={form.receivedFrom}  /> */}
            </div>
            <div className="DDfields">
              <label> A/C. No.  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(खाता सं.)</label>
              {/* <input name="acNo" value={form.acNo}  /> */}
            </div>
            <div className="DDfields">
              <label>Nominee Name  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(नामांकित व्यक्ति का नाम)</label>
              {/* <input name="nomineeName" value={form.nomineeName}  /> */}
            </div>
            <div className="DDfields">
              <label>Types of Deposit  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(जमा के प्रकार)</label>
              {/* <input
                name="typesOfDeposit"
                value={form.typesOfDeposit}
                
              /> */}
            </div>
          </div>

          <div className="DDrights-info">
            <div className="DDfields">
              <label> Date  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(दिनांक)</label>
              {/* <input name="date" value={form.date}  /> */}
            </div>
            <div className="DDfields">
              <label>Age  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(आयु)</label>
              {/* <input name="age" value={form.age}  /> */}
            </div>
            <div className="DDfields">
              <label>Relation  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(रिश्ता)</label>
              {/* <input name="relation" value={form.relation}  /> */}
            </div>
            <div className="DDfields">
              <label>A/C. No.  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(खाता सं.)</label>
              {/* <input name="acNo" value={form.acNo}  /> */}
            </div>
          </div>
        </div>

      
    <div className="DDCdeposit-table">
      <table>
        <thead>
          <tr>
            <th>
              {/* Per Month Rs. <br /> */}
              <span className="DDCsub">Per Month Rs. <br /> प्रति माह रु.</span>
            </th>
            <th colSpan="2">
              
              <span className="DDCsubs">Deposit Date / जमा तिथि</span>
              <div className="DDCsub-header">
                <div className="DDCsub">Start Date <br /> प्रारंभ तारीख</div>
                <div className="DDCsub">Maturity Date <br /> परिपक्वता तिथि</div>
              </div>
            </th>
            <th>
              {/* Duration <br /> */}
              <span className="DDCsub">Duration <br /> अवधि</span>
            </th>
            <th>
              {/* Interest Rate <br /> */}
              <span className="DDCsub">Interest Rate <br /> व्याज दर</span>
            </th>
            <th>
              {/* Due Date <br /> */}
              <span className="DDCsub">Due Date <br />नियत तारीख</span>
            </th>
            <th>
              {/* Maturity Amt. <br /> */}
              <span className="DDCsub">Maturity Amt.<br /> परिपक्वता राशि</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td className="inner"></td>
            <td className="inner"></td>
            <td> <br /><br /><br />  </td>
            <td>   </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
     <div className="DDfooter">
          <div><br /> Cashier / कैशियर</div>
          <div><br /> Br. Manager / शाखाप्रमुख</div>
          <div><br /> Chairman / अध्यक्ष</div>  
      </div>
       </div>  </div></div>
      {/* End of 2nd Container */}

      {/* start of 1st Notice */}
 <div className="DDdivider"></div>
     <div id="page2">
    <div className="DDCnotice-container">
      {/* --- Heading --- */}
      <div className="DDCspecial-notice-header">
        <span className="DDCenglish-heading">Special Notice / </span>
        <span className="DDCmarathi-heading">विशेष सुचना</span>
      </div>

      {/* --- Rules/Points Section --- */}
      <div className="DDCrules-section">
        {/* Point 1 */}
        <div className="DDCrule-item">
          <span className="DDCrule-number">१)</span>
          <div className="DDCrule-text">
            <p className="DDCmarathi-text">
              डिमांड ड्राफ्ट में राशि निवेश करने के बाद जमा रसीद दी जाएगी और रसीद जमा करने के बाद, समाप्ति तिथि के बाद परिपक्वता राशि का भुगतान किया जाएगा।
            </p>
            <p className="DDCenglish-text">
              Deposit receipt will be given after investing the amount in the recurring deposits and After submission of receipt, Maturity amount will be paid after the expiry date.
            </p>
          </div>
        </div>

        {/* Point 2 */}
        <div className="DDCrule-item">
          <span className="DDCrule-number">२)</span>
          <div className="DDCrule-text">
            <p className="DDCmarathi-text">
              यदि रसीद खो जाए या क्षतिग्रस्त हो जाए तो स्टाम्प पेपर पर वैधता बनाना आवश्यक है।
            </p>
            <p className="DDCenglish-text">
              If the receipt is lost or damaged, then it is necessary to make a validity on the stamp paper.
            </p>
          </div>
        </div>

        {/* Point 3 */}
        <div className="DDCrule-item">
          <span className="DDCrule-number">३)</span>
          <div className="DDCrule-text">
            <p className="DDCmarathi-text">
              यदि खाता अवधि से पहले बंद हो जाता है, तो संगठन के नियमों के अनुसार ब्याज का भुगतान किया जाएगा।
            </p>
            <p className="DDCenglish-text">
              In case the account will stop before period, interest will be paid as per organization's rules.
            </p>
          </div>
        </div>
      </div>

      {/* --- Table Section --- */}
        <div className="DDCsdeposit-table">
      <table>
        <thead>
          <tr>
            <th>
              {/* Per Month Rs. <br /> */}
              <span className="DDCssub">Per Month Rs. <br /> प्रति माह रु.</span>
            </th>
            <th colSpan="2">
              
              <span className="DDCssubs">Deposit Date / जमा तिथि</span>
              <div className="DDCssub-header">
                <div className="DDCssub">Start Date <br /> प्रारंभ तारीख</div>
                <div className="DDCssub">Maturity Date <br /> परिपक्वता तिथि</div>
              </div>
            </th>
            <th>
              {/* Duration <br /> */}
              <span className="DDCssub">Duration <br /> अवधि</span>
            </th>
            <th>
              {/* Interest Rate <br /> */}
              <span className="DDCssub">Interest Rate <br /> व्याज दर</span>
            </th>
            <th>
              {/* Due Date <br /> */}
              <span className="DDCssub">Due Date <br />नियत तारीख</span>
            </th>
            <th>
              {/* Maturity Amt. <br /> */}
              <span className="DDCssub">Maturity Amt.<br /> परिपक्वता राशि</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td className="inner"></td>
            <td className="inner"></td>
            <td> <br /><br /><br />  </td>
            <td>   </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
      {/* --- Footer/Signature Section --- */}
      <div className="DDCsignature-section">
        <div className="DDCreceipt-confirmation">
          <p className="DDCenglish-text">
            I received the amount along with the interest of the deposit as shown in the order.
          </p>
          <p className="DDCmarathi-text">
            मुझे आदेश में दर्शाई गई राशि के साथ-साथ जमा राशि पर ब्याज भी प्राप्त हुआ।
          </p>
        </div>
        <div className="DDCsignature-box-container">
          <div className="DDCsignature-box"></div>
          <div className="DDCsignature-labels">
            <p className="DDCenglish-text">**Signature of the account holder**</p>
            <p className="DDCmarathi-text">**खाताधारक के हस्ताक्षर**</p>
          </div>
        </div>
      </div>
    </div>

     {/* End  of 1st Notice */}
 <div className="DDdivider"></div>
    <div className="DDCnotice-container">
      {/* --- Heading --- */}
      <div className="DDCspecial-notice-header">
        <span className="DDCenglish-heading">Special Notice / </span>
        <span className="DDCmarathi-heading">विशेष सुचना</span>
      </div>

      {/* --- Rules/Points Section --- */}
      <div className="DDCrules-section">
        {/* Point 1 */}
        <div className="DDCrule-item">
          <span className="DDCrule-number">१)</span>
          <div className="RDCrule-text">
            <p className="DDCmarathi-text">
              डिमांड ड्राफ्ट में राशि निवेश करने के बाद जमा रसीद दी जाएगी और रसीद जमा करने के बाद, समाप्ति तिथि के बाद परिपक्वता राशि का भुगतान किया जाएगा।
            </p>
            <p className="DDCenglish-text">
              Deposit receipt will be given after investing the amount in the recurring deposits and After submission of receipt, Maturity amount will be paid after the expiry date.
            </p>
          </div>
        </div>

        {/* Point 2 */}
        <div className="DDCrule-item">
          <span className="DDCrule-number">२)</span>
          <div className="DDCrule-text">
            <p className="DDCmarathi-text">
              यदि रसीद खो जाए या क्षतिग्रस्त हो जाए तो स्टाम्प पेपर पर वैधता बनाना आवश्यक है।
            </p>
            <p className="DDCenglish-text">
              If the receipt is lost or damaged, then it is necessary to make a validity on the stamp paper.
            </p>
          </div>
        </div>

        {/* Point 3 */}
        <div className="DDCrule-item">
          <span className="DDCrule-number">३)</span>
          <div className="DDCrule-text">
            <p className="DDCmarathi-text">
              यदि खाता अवधि से पहले बंद हो जाता है, तो संगठन के नियमों के अनुसार ब्याज का भुगतान किया जाएगा।
            </p>
            <p className="DDCenglish-text">
              In case the account will stop before period, interest will be paid as per organization's rules.
            </p>
          </div>
        </div>
      </div>

      {/* --- Table Section --- */}
        <div className="DDCsdeposit-table">
      <table>
        <thead>
          <tr>
            <th>
              {/* Per Month Rs. <br /> */}
              <span className="DDCssub">Per Month Rs. <br /> प्रति माह रु.</span>
            </th>
            <th colSpan="2">
              
              <span className="DDCssubs">Deposit Date / जमा तिथि</span>
              <div className="DDCssub-header">
                <div className="DDCssub">Start Date <br /> प्रारंभ तारीख</div>
                <div className="DDCssub">Maturity Date <br /> परिपक्वता तिथि</div>
              </div>
            </th>
            <th>
              {/* Duration <br /> */}
              <span className="DDCssub">Duration <br /> अवधि</span>
            </th>
            <th>
              {/* Interest Rate <br /> */}
              <span className="DDCssub">Interest Rate <br /> व्याज दर</span>
            </th>
            <th>
              {/* Due Date <br /> */}
              <span className="DDCssub">Due Date <br />नियत तारीख</span>
            </th>
            <th>
              {/* Maturity Amt. <br /> */}
              <span className="DDCssub">Maturity Amt.<br /> परिपक्वता राशि</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td className="inner"></td>
            <td className="inner"></td>
            <td> <br /><br /><br />  </td>
            <td>   </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
      {/* --- Footer/Signature Section --- */}
      <div className="DDCsignature-section">
        <div className="DDCreceipt-confirmation">
          <p className="DDCenglish-text">
            I received the amount along with the interest of the deposit as shown in the order.
          </p>
          <p className="DDCmarathi-text">
            मुझे आदेश में दर्शाई गई राशि के साथ-साथ जमा राशि पर ब्याज भी प्राप्त हुआ।
          </p>
        </div>
        <div className="DDCsignature-box-container">
          <div className="DDCsignature-box"></div>
          <div className="DDCsignature-labels">
            <p className="DDCenglish-text">**Signature of the account holder**</p>
            <p className="DDCmarathi-text">**खाताधारक के हस्ताक्षर**</p>
          </div>
        </div>
      </div>
    </div></div>
    <button className="DDCpdf-button" onClick={generatePDF}>Download PDF</button>
  </div>
  
  );
}